import { RecordingSeriesModel, ProgramSeriesModel } from '@24i/st-api-connector';

const toSeries = (itemArray) => {
    const seriesModel = new ProgramSeriesModel(itemArray.map((tv) => tv.data));
    seriesModel.data = { ...itemArray[0].data, episodeId: null, episodeTitle: null };
    return seriesModel;
};

const toRecordingSeries = (itemArray) => {
    const seriesModel = new RecordingSeriesModel(itemArray.map((rec) => rec.data));
    seriesModel.data = { id: itemArray[0].data.id };
    return seriesModel;
};

export const groupSearchToSeries = (searchResult) => {
    const liveResult = [];
    if (searchResult?.programs) {
        const serialisedLive = [];
        searchResult.programs.forEach((program) => {
            const index = serialisedLive.findIndex(
                (programArray) =>
                    programArray[0].data.seriesId &&
                    programArray[0].data.seriesId === program.data?.seriesId
            );
            if (index >= 0) serialisedLive[index].push(program);
            else serialisedLive.push([program]);
        });
        liveResult.push(
            ...serialisedLive.map((rArr) => (rArr.length > 1 ? toSeries(rArr) : rArr[0]))
        );
    }
    const recordingResult = [];
    if (searchResult?.recordings) {
        const serialisedRecordings = [];
        searchResult.recordings.forEach((recording) => {
            const index = serialisedRecordings.findIndex(
                (recordingArray) =>
                    recordingArray[0].data.schedule.program.programValue.seriesId &&
                    recordingArray[0].data.schedule.program.programValue.seriesId ===
                        recording.data?.schedule?.program?.programValue?.seriesId
            );
            if (index >= 0) serialisedRecordings[index].push(recording);
            else serialisedRecordings.push([recording]);
        });
        recordingResult.push(
            ...serialisedRecordings.map((rArr) =>
                rArr.length > 1 ? toRecordingSeries(rArr) : rArr[0]
            )
        );
    }

    return {
        programs: liveResult,
        recordings: recordingResult
    };
};

export const groupV3SearchToSeries = (searchResult) => {
    const channelsResult = [];
    const actorsAndDirectorsResult = [];
    const liveResult = [];
    const archiveTvProgramsResult = [];
    const futureTvProgramsResult = [];
    const moviesResult = [];
    const seriesResult = [];
    const recordingResult = [];

    if (searchResult?.channels) {
        const serialisedChannels = [];
        searchResult.channels.forEach((channel) => {
            serialisedChannels.push([channel]);
        });
        channelsResult.push(
            ...serialisedChannels.map((rArr) => (rArr.length > 1 ? toSeries(rArr) : rArr[0]))
        );
    }

    if (searchResult?.actorsAndDirectors) {
        const serialisedActorsAndDirectors = [];
        searchResult.actorsAndDirectors.forEach((actorsAndDirector) => {
            serialisedActorsAndDirectors.push([actorsAndDirector]);
        });
        actorsAndDirectorsResult.push(
            ...serialisedActorsAndDirectors.map((rArr) =>
                rArr.length > 1 ? toSeries(rArr) : rArr[0]
            )
        );
    }

    if (searchResult?.movies) {
        const serialisedMovies = [];
        searchResult.movies.forEach((movie) => {
            serialisedMovies.push([movie]);
        });
        moviesResult.push(
            ...serialisedMovies.map((rArr) => (rArr.length > 1 ? toSeries(rArr) : rArr[0]))
        );
    }

    if (searchResult?.recordings) {
        const serialisedRecordings = [];
        searchResult.recordings.forEach((recording) => {
            serialisedRecordings.push([recording]);
        });
        recordingResult.push(
            ...serialisedRecordings.map((rArr) =>
                rArr.length > 1 ? toRecordingSeries(rArr) : rArr[0]
            )
        );
    }

    if (searchResult?.series) {
        const serialisedSeries = [];
        searchResult.series.forEach((serie) => {
            const index = serialisedSeries.findIndex(
                (programArray) =>
                    programArray[0].data.seriesId &&
                    programArray[0].data.seriesId === serie.data?.seriesId
            );
            if (index >= 0) serialisedSeries[index].push(serie);
            else serialisedSeries.push([serie]);
        });
        seriesResult.push(
            ...serialisedSeries.map((rArr) => (rArr.length > 1 ? toSeries(rArr) : rArr[0]))
        );
    }

    if (searchResult?.futureTvPrograms) {
        const serialisedFutureTvPrograms = [];
        searchResult.futureTvPrograms.forEach((futureTvProgram) => {
            serialisedFutureTvPrograms.push([futureTvProgram]);
        });
        futureTvProgramsResult.push(
            ...serialisedFutureTvPrograms.map((rArr) =>
                rArr.length > 1 ? toSeries(rArr) : rArr[0]
            )
        );
    }

    if (searchResult?.archiveTvPrograms) {
        const serialisedArchiveTvPrograms = [];
        searchResult.archiveTvPrograms.forEach((archiveTvProgram) => {
            serialisedArchiveTvPrograms.push([archiveTvProgram]);
        });
        archiveTvProgramsResult.push(
            ...serialisedArchiveTvPrograms.map((rArr) =>
                rArr.length > 1 ? toSeries(rArr) : rArr[0]
            )
        );
    }

    if (searchResult?.liveTvPrograms) {
        const serialisedLive = [];
        searchResult.liveTvPrograms.forEach((liveTvProgram) => {
            serialisedLive.push([liveTvProgram]);
        });
        liveResult.push(
            ...serialisedLive.map((rArr) => (rArr.length > 1 ? toSeries(rArr) : rArr[0]))
        );
    }

    return {
        channels: channelsResult.length > 0 ? channelsResult : null,
        actorsAndDirectors: actorsAndDirectorsResult.length > 0 ? actorsAndDirectorsResult : null,
        liveTvPrograms: liveResult.length > 0 ? liveResult : null,
        archiveTvPrograms: archiveTvProgramsResult.length > 0 ? archiveTvProgramsResult : null,
        futureTvPrograms: futureTvProgramsResult.length > 0 ? futureTvProgramsResult : null,
        movies: moviesResult.length > 0 ? moviesResult : null,
        series: seriesResult.length > 0 ? seriesResult : null,
        recordings: recordingResult.length > 0 ? recordingResult : null
    };
};
